// extracted by mini-css-extract-plugin
export default {"root":"Bootstrap_root__04f06"};